module.exports = __webpack_public_path__ + "img/logo-13.f3a6bd47.png";